import React from 'react';

import { useTimer } from '../../../../../../shared/hooks/useTimer';
import classes from './Timer.module.scss';
import { TimeUnit } from './TimeUnit/TimeUnit';

type TimerProps = {
  expirationEpoch: number;
};

const Timer = ({ expirationEpoch }: TimerProps) => {
  const { days, hours, minutes, seconds } = useTimer(expirationEpoch);

  return (
    <div className={classes.timer}>
      <TimeUnit value={days} label="days" />
      <span className={classes.separator}>:</span>
      <TimeUnit value={hours} label="hours" />
      <span className={classes.separator}>:</span>
      <TimeUnit value={minutes} label="minutes" />
      <span className={classes.separator}>:</span>
      <TimeUnit value={seconds} label="seconds" />
    </div>
  );
};

export { Timer };
